export default __webpack_public_path__ + "static/media/project_gm_eshop_1.2cdb89c4.png";